import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 mt-24 bg-ink-900" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-4 mb-3">
            <img
              src="/logo.png"
              alt="WorldFoods2U"
              className="w-16 h-16 object-contain drop-shadow-[0_0_22px_rgba(212,175,55,0.4)]"
            />
            <div className="font-display text-3xl tracking-tight text-cream">WorldFoods2U</div>
          </div>
          <p className="text-xs uppercase tracking-[0.3em] text-gold/80">Origin to Market</p>
          <p className="text-muted text-sm mt-4 max-w-xs leading-relaxed">
            The global B2B marketplace for verified spices and agri produce, sourced anonymously from farms across 40+ countries.
          </p>
        </div>
        <div>
          <div className="section-label mb-4">Marketplace</div>
          <ul className="space-y-2 text-sm text-cream/80">
            <li><Link to="/shop">All Spices</Link></li>
            <li><Link to="/shop?parent=Spices">Premium Grade</Link></li>
            <li><Link to="/shop?organic=true">Organic</Link></li>
            <li><Link to="/shop?parent=Agri">Agri Produce</Link></li>
          </ul>
        </div>
        <div>
          <div className="section-label mb-4">Trust</div>
          <ul className="space-y-2 text-sm text-cream/80">
            <li>Verified farmers</li>
            <li>Escrow payments</li>
            <li>Anonymous fulfillment</li>
            <li>Global shipping</li>
          </ul>
        </div>
        <div>
          <div className="section-label mb-4">Company</div>
          <ul className="space-y-2 text-sm text-cream/80">
            <li><Link to="/about">Our Story</Link></li>
            <li><Link to="/login">Join as Farmer</Link></li>
            <li><Link to="/login">Join as Buyer</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted">© {new Date().getFullYear()} WorldFoods2U. Trusted by 500+ farms globally.</p>
          <p className="text-xs tracking-[0.3em] uppercase text-gold/70">Est. 2025 • 40 Countries</p>
        </div>
      </div>
    </footer>
  );
}
